// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.schedule-wrapper {
  display: flex;
  flex-direction: column;
}

.schedule-container {
  display: flex;
  flex-direction: column;
  margin-bottom: 24px;
}
.schedule-container h3 {
  font-weight: bold;
  margin-bottom: 21px;
  width: fit-content;
}
.schedule-container__details {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 18px;
}
.schedule-container__details .button--grey {
  width: 49px;
  height: 56px;
}
.schedule-container__date {
  display: flex;
  justify-content: flex-start;
  font-size: 16px;
  height: fit-content;
}
.schedule-container__date img {
  width: 16px;
  margin-right: 8px;
  height: fit-content;
}
.schedule-container__date p {
  height: fit-content;
}
.schedule-container__invalid {
  color: red;
}
.schedule-container .schedule-container__details {
  padding-left: 5px;
}
.schedule-container .schedule-container__details span {
  line-height: unset;
  display: flex;
  flex-direction: column;
}
.schedule-container .schedule-container__details button {
  height: 30px;
  width: 30px;
  margin-bottom: 2px;
}`, "",{"version":3,"sources":["webpack://./src/components/FirstMarketplaceScheduler/FirstMarketplaceScheduler.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AACF;AAAE;EACE,iBAAA;EACA,mBAAA;EACA,kBAAA;AAEJ;AAAE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAEJ;AADI;EACE,WAAA;EACA,YAAA;AAGN;AAAE;EACE,aAAA;EACA,2BAAA;EACA,eAAA;EACA,mBAAA;AAEJ;AAAI;EACE,WAAA;EACA,iBAAA;EACA,mBAAA;AAEN;AAAI;EACE,mBAAA;AAEN;AACE;EACE,UAAA;AACJ;AACE;EACE,iBAAA;AACJ;AAAI;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;AAEN;AAAI;EACE,YAAA;EACA,WAAA;EACA,kBAAA;AAEN","sourcesContent":[".schedule-wrapper {\n  display: flex;\n  flex-direction: column;\n}\n\n.schedule-container {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 24px;\n  h3 {\n    font-weight: bold;\n    margin-bottom: 21px;\n    width: fit-content;\n  }\n  &__details {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 18px;\n    .button--grey {\n      width: 49px;\n      height: 56px;\n    }\n  }\n  &__date {\n    display: flex;\n    justify-content: flex-start;\n    font-size: 16px;\n    height: fit-content;\n\n    img {\n      width: 16px;\n      margin-right: 8px;\n      height: fit-content;\n    }\n    p {\n      height: fit-content;\n    }\n  }\n  &__invalid {\n    color: red;\n  }\n  .schedule-container__details {\n    padding-left: 5px;\n    span {\n      line-height: unset;\n      display: flex;\n      flex-direction: column;\n    }\n    button {\n      height: 30px;\n      width: 30px;\n      margin-bottom: 2px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
